import {AfterViewInit, Component, OnDestroy, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges} from "@angular/core";
import { Subject, Subscription, debounceTime } from 'rxjs';
import { NumberUtil } from "../../utils/number.util";
import { Constant } from "../../../pages/general/blog/constant";
/**
 * declare Jquery
 * */
declare let $: any;

@Component({
  selector: 'input-number',
  templateUrl: "./input-number.html",
  styleUrls: ['./input-number.scss'],
})

export class InputNumberComponent implements OnInit, OnChanges {
    @Input('amount') amount: any;
    @Input('unit') unit: any;
    @Input('maxLength') maxLength: any;
    @Input('placeholder') placeholder: any;
    @Input('disabled') disabled: boolean = false;
    @Input('isDecimal') isDecimal: boolean = false;
    @Input('maxLengthDecimal') maxLengthDecimal: any;
    @Input('isInteger') isInteger: boolean = true;
    @Input('isSeparate') isSeparate: boolean = true;
    @Output() amountChange: EventEmitter<any> = new EventEmitter();
    @Output() result: EventEmitter<any> = new EventEmitter();
    amountText: string = '';
    Constant = Constant;
    callApi$ = new Subject();
    beforeKeydown: any;
    @Input('id') id: string = 'input-' + (Math.random() * 1000) + (Math.random() * 1000);
    constructor(
    ) {

    }
    ngOnInit() {
        this.callApi$.pipe(
            debounceTime(100),
            ).subscribe((event)=> { return this.parseData();});
    }
    ngOnChanges(simpleChanges: SimpleChanges) {
        const changes: any = simpleChanges;
        if (changes.amount && changes.amount.currentValue) {
            this.changeText();
        }
    }
    changeValue() {
        this.callApi$.next(true);
    }
    parseData() {
        this.checkValidateData();
        if (this.isSeparate) {
            this.changeText();
        }
        this.amountChange.emit(this.amount);
        this.result.emit(this.amount);
    }
    checkValidateData() {
        if (this.isSeparate) {
            this.amount = this.amountText ? NumberUtil.revertMoneytoNumber(this.amountText) : null;
            if (this.amount === null) {
                return;
            }
            if (this.isDecimal) {
                this.amount = NumberUtil.decimalAdjust(this.amount, this.maxLengthDecimal);
            } else {
                this.amount = Math.round(this.amount);
            }

            if (this.isInteger) {
                if (this.amount < 0) {
                    this.amount = this.amount * -1;
                }
            }
        } else {
            this.amount = this.amountText || null;
        }
        if (this.amount === null) {
            return;
        }
       
        if (this.maxLength && this.isSeparate) {
            const split = (this.amount + '').split('.');
            const amountInterger = (this.amount + '').split('.')[0] || '';
            if (amountInterger.length > this.maxLength) {
                let amount = '';
                for(let i=0 ; i < this.maxLength; i++) {
                    amount+= '9';
                }
                this.amount = split[1] ? amount + '.' + split[1] : amount;
            }
        }
    }
    changeText() {
        if (!this.isSeparate) {
            this.amountText = this.amount !== null ? this.amount + '' : '';
            return;
        }
        let changeText = this.amount ? NumberUtil.numberToMoney(this.amount) : '';
        changeText = changeText !== '0' ? changeText : '';
        if (changeText !== this.amountText && changeText + '.' !== this.amountText) {
            setTimeout(() => {
                this.amountText = changeText;
            }, 10)
        }
    }
    catchKeydown(event: any) {
        const key = event.key;
     
        const textField : any = document.getElementById(this.id);
        const cursorPosition = textField.selectionStart;
        
        // input decimal
        if ( this.isDecimal && key === '.') {
            const amount = (this.amountText || '').replaceAll(',', '');
            const positionDots = amount.indexOf('.');
            if (positionDots > -1) {
                event.preventDefault();
            }
            return;
        }

        // input negative
        if ( !this.isInteger && key === '-') {
            return;
        }   

        if (key === 'Backspace' || key === 'ArrowLeft' || key === 'ArrowRight' || key === 'Tab' || key === 'Delete') {
           return;
        }

        if (key === 'Control') {
            this.beforeKeydown = key;
        }

        if ((key === 'v' && this.beforeKeydown === 'Control'  )) {
            this.beforeKeydown = '';
            return;
        }

        if ((key === 'c' && this.beforeKeydown === 'Control'  )) {
            this.beforeKeydown = '';
            return;
        }
        if ((key === 'a' && this.beforeKeydown === 'Control'  )) {
            this.beforeKeydown = '';
            return;
        }
        if ((key === 'x' && this.beforeKeydown === 'Control'  )) {
            this.beforeKeydown = '';
            return;
        }

        if (key >= '0' && key <= '9') {
          
            const selection: any = document.getSelection();
            const sec = selection.getRangeAt(0);
            // if (sec.startContainer === sec.endContainer) {
            //     return;
            // }
            const amount = (this.amountText || '').replaceAll(',', '');
            if (!this.isSeparate && amount.length === this.maxLength) {
                event.preventDefault();
                return;
            }
            const positionDots = amount.indexOf('.');
            if (cursorPosition <= positionDots || positionDots === -1) {
                if (this.maxLength) {
                    const lengthNumber = ((amount + '').split('.')[0] || '').length;
                    if (lengthNumber >= this.maxLength) {
                        event.preventDefault();
                        return;
                    }
                }
            } else {
                if (this.isDecimal) {
                    const lengthDecimal = ((amount + '').split('.')[1] || '').length;
                    if (lengthDecimal >= this.maxLengthDecimal) {
                        event.preventDefault();
                        return;
                    }
                }
            }
        }

        if (key < '0' || key > '9') {
            event.preventDefault();
            return;
        }
        return;
    }
}
